
import React, { useState, useEffect, useContext, createContext, Component } from 'react';
import ReactDOM from 'react-dom';
import serialize from 'form-serialize';
import axios from 'axios';
import { Route, Redirect } from 'react-router-dom';

import {api_path} from '../../server.js'; 

import Header from '../../components/Header';

//import { useHistory, useParams } from 'react-router-dom';


function AnaliseSoloResultado() {

  const [analise, setAnalise] = useState();
  const [textoLaudo, setTextoLaudo] = useState();

  useEffect(()=>{

    const storageUser = localStorage.getItem("SistemaUser");
    if(storageUser){
        let storageSistemaUser = JSON.parse(storageUser);
        
        //setLoading(false);
        let solo_id = storageSistemaUser.solo_id;
        let user_id = storageSistemaUser.user_id;

        setAnalise(solo_id);
    }

    const bodyFert = {
      acao: 'getLaudo',
      analise: analise
    }

    axios.post(api_path()+'sistema/analisesolo/analise_solo_fertilizantes.php', bodyFert, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
    .then((response) => {

      let dadosAdubacao = response.data;
      let dadosAdubacaoTexto = dadosAdubacao.texto;
      setTextoLaudo(dadosAdubacaoTexto);


        })
        .catch(function (response) {
            console.log(response);
        });
        return;

}, [analise])


function createMarkup() {
  return {__html: textoLaudo};
}


    return (

      <div className="App">

          <Header/>
          <div className="AppContainer">
            <h1>Resultado</h1>

            <div dangerouslySetInnerHTML={createMarkup()} />

          </div>
      </div>


    );
  }

  export default AnaliseSoloResultado;
